import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { reportWebVitals, preloadCriticalResources, registerServiceWorker, logBundleInfo } from './utils/performance';
import { preloadCriticalComponents } from './utils/lazyImports';
import 'bootstrap/dist/css/bootstrap.min.css';

// Initialize performance optimizations
preloadCriticalResources();
registerServiceWorker();
logBundleInfo();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Preload critical components after initial render
setTimeout(() => {
  preloadCriticalComponents();
}, 1000);

// Performance monitoring
reportWebVitals((metric) => {
  // Log performance metrics in development
  if (process.env.NODE_ENV === 'development') {
    console.log(metric);
  }
  
  // In production, you could send these to an analytics service
  // analytics.track('Web Vital', metric);
});